import { IResult } from "@/types/map";
import { loadModules } from "esri-loader";

export default class MeasureModel_ArcGIS {
  private static intances: Map<string, MeasureModel_ArcGIS>;

  public static getInstance(view: __esri.View) {
    const id = view.container.id;
    if (!MeasureModel_ArcGIS.intances) {
      MeasureModel_ArcGIS.intances = new Map();
    }
    let instance = MeasureModel_ArcGIS.intances.get(id);
    if (!instance) {
      instance = new MeasureModel_ArcGIS(view);
      MeasureModel_ArcGIS.intances.set(id, instance);
    }
    return instance;
  }

  private view: __esri.View;

  constructor(view: __esri.View) {
    this.view = view;
  }

  private initialized = false;
  private distanceMeasurement!: __esri.DistanceMeasurement2DViewModel;
  private areaMeasurement!: __esri.AreaMeasurement2DViewModel;

  private async initialize() {
    type MapModules = [
      typeof import("esri/widgets/DistanceMeasurement2D/DistanceMeasurement2DViewModel"),
      typeof import("esri/widgets/AreaMeasurement2D/AreaMeasurement2DViewModel")
    ];
    const [
      DistanceMeasurement2DViewModel,
      AreaMeasurement2DViewModel,
    ] = await (loadModules([
      "esri/widgets/DistanceMeasurement2D/DistanceMeasurement2DViewModel",
      "esri/widgets/AreaMeasurement2D/AreaMeasurement2DViewModel",
    ]) as Promise<MapModules>);
    this.distanceMeasurement = new DistanceMeasurement2DViewModel({
      view: this.view,
      unit: "meters",
    });
    this.areaMeasurement = new AreaMeasurement2DViewModel({
      view: this.view,
      unit: "square-meters",
    });
    this.initialized = true;
  }

  public async measure_length(): Promise<IResult> {
    if (!this.initialized) {
      await this.initialize();
    }
    this.distanceMeasurement.start();
    return new Promise<IResult>((resolve) => {
      this.distanceMeasurement.watch("state ", (state: string) => {
        if (state === "measured") {
          const length = this.distanceMeasurement.measurement.length;
          resolve({
            status: 0,
            message: "",
            result: Number(length.toFixed(2)),
          });
        }
      });
    });
  }

  public async measure_area(): Promise<IResult> {
    if (!this.initialized) {
      await this.initialize();
    }
    this.areaMeasurement.start();
    return new Promise<IResult>((resolve) => {
      (this.areaMeasurement as any).watch("state", (state: string) => {
        if (state === "measured") {
          const area = this.areaMeasurement.measurement.area / 1000000;
          resolve({
            status: 0,
            message: "",
            result: Number(area.toFixed(4)),
          });
        }
      });
    });
  }

  public measure_clear() {
    if (this.distanceMeasurement) {
      this.distanceMeasurement.clear();
    }
    if (this.areaMeasurement) {
      this.areaMeasurement.clear();
    }
  }
}
